import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AxiosError, AxiosResponse } from 'axios';
import { parseErrorCode } from '../../../../utils/validation/error-codes';
import { PropertyNameError } from '../../types/errors';

export const useApiErrors = () => {
  const { t } = useTranslation('backend-validation');
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleErrors = (error: AxiosError) => {
    const response = error.response;
    const errors: Record<string, string> = {};

    if (response) {
      if ('errors' in (response as AxiosResponse).data) {
        const errorObject = (response as AxiosResponse).data.errors as Record<string, string>;

        Object.keys(errorObject).map((x) => {
          const errorParsed = JSON.parse(errorObject[x]) as PropertyNameError;
          const errorCode = parseErrorCode(errorParsed, t);

          errors[errorParsed.PropertyName] = errorCode;
        });
      }
    }

    setErrors(errors);
  };

  const clearErrors = () => setErrors({});

  return {
    errors,
    handleErrors,
    clearErrors,
  };
};
